import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

export default function AuthenticatedRoute({children}) {
    const {currentUser, loading} = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="h-8 w-8 border-[3px] border-gray-300 border-t-blue-500 rounded-full animate-spin" />
            </div>
        );
    }

    return currentUser
        ? children
        : <Navigate to="/login" state={{from: location}} replace />;
}
